import React from 'react';
import styled, { css } from 'styled-components';

import { basic, grey } from '../../theme/colors';

const Counter = styled.div<{ onClick?: () => void }>`
  vertical-align: middle;
  transition: 150ms ease all;
  display: inline-block;
  text-align: center;
  height: 20px;
  width: 20px;
  opacity: 1;
  position: relative;
  top: 0;
  overflow: hidden;
  border: 1px solid ${basic.haydenAccent};
  line-height: 1rem;
  border-radius: 100%;
  color: ${grey.haydenGreyShade1};
  font-size: 12px;
  font-weight: 400;
  margin-left: 0.5em;
  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}
`;

interface Props {
  counter?: number;
  onClick?: () => void;
}

export const BadgeCounter = ({ counter, onClick }: Props) => {
  if (!counter) {
    return null;
  }
  return <Counter onClick={onClick}>{counter}</Counter>;
};
